export const localStorageKeys = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  filtersTransactions: 'filtersTransactions',
  confirmationEmailAccount: 'confirmationEmailAccount',
};
